import { render, staticRenderFns } from "./LoginRestore.vue?vue&type=template&id=1ac5acd2&"
import script from "./LoginRestore.vue?vue&type=script&lang=js&"
export * from "./LoginRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports